import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import BillingDetailsCard from '@/shared-components/payment-profile/BillingDetailsCard';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

export default function InvoiceDialog({
  entry,
  onClose,
  statusMessage,
  billingRequired,
  onBillingSaved,
  invoiceUrl,
  onOpenInvoice,
  onRequestGalleryInvoice,
  isGalleryInvoiceDisabled,
  isGalleryInvoiceLoading,
}) {
  return (
    <GenericPopup open={Boolean(entry)} onBackgroundClick={onClose} opacity className="generic-popup_content profile-payments__popup">
      <div className="generic-popup__header profile-payments__popup-header">
        <Text className="generic-popup__header-text profile-payments__popup-title ">Invoice</Text>
        <XIcon className="generic-popup__close profile-payments__popup-close" onClick={onClose} />
      </div>
      <div className="profile-payments__invoice-body">
        <Text className="">{entry?.orderNumber ? `Order #${entry.orderNumber}` : 'Payment invoice'}</Text>
        {statusMessage && <Text className="profile-payments__invoice-message ">{statusMessage}</Text>}
        {billingRequired && (
          <BillingDetailsCard
            className="profile-payments__invoice-billing-card"
            billingAddress={entry?.billingAddress ?? null}
            billingInfo={entry?.billingInfo ?? null}
            shippingAddress={entry?.orderShippingAddress ?? null}
            onSaved={onBillingSaved}
          />
        )}
        <div className="profile-payments__invoice-actions">
          {invoiceUrl && <ContinueButton onClick={() => onOpenInvoice(entry)}>Open invoice</ContinueButton>}
          {String(entry?.type ?? '').toLowerCase() === 'original' && (
            <ContinueButton onClick={() => onRequestGalleryInvoice(entry)} turnOff={isGalleryInvoiceDisabled}>
              {isGalleryInvoiceLoading ? 'Requesting...' : 'Request gallery invoice'}
            </ContinueButton>
          )}
        </div>
      </div>
    </GenericPopup>
  );
}
